import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import INSDAPIPortal from './page';
import Documentation from './Documentation';
import Dashboard from './Dashboard';

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<INSDAPIPortal />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </Router>
  );
}

export default App;
